"use client"
import React, { Suspense } from "react"
// import { SectorFooter } from "trimble-terra/SectorFooter"
import { SectorFooter } from "trimble-terra"
import { getProfile } from "@/profiles/getProfile"
import './SiteFooter.css'

export default function FormatSiteFooter({ data, urlLocale }: { data: any, urlLocale?: string }) {
  const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE);
  const prefix = profile.NAV_BASE_URL || "https://www.trimble.com/en"
  const parentUrlLocale = urlLocale || 'en'
  
  const processLinkUrl = (link: any) => {

    if(link?.url?.__typename === 'PageProductPage') {
      return `${prefix}/${parentUrlLocale}/products/${link?.url?.slug}`
    } else if(link?.internalLink) {
      return `${prefix}/${parentUrlLocale}/${link?.internalLink}`
    } else if (link?.url?.url && link?.url?.__typename === 'ExternalLink' ) {
      return link?.url?.url
    } else if(link?.url?.url && link?.url?.__typename != 'ExternalLink'){
      return `${prefix}/${parentUrlLocale}/${link?.url?.url}`
    } else if(link?.url?.slug ){
      return `${prefix}/${parentUrlLocale}/${link?.url?.slug}` 
    } else {
      return null
    }
  }
  
  const formattedFooterData = {
    socialLinksTitle: data?.socialLinksTitle,
    socialLinks: data?.socialLinksCollection?.items?.map((item: any) => {
      return {
        siteName: item?.siteName,
        link: {
          url: item?.url || null
        }
      }
    }),
    footerVariant: data?.footerVariant,

    sectorFooterLinks: data?.sectorFooterMenusCollection?.items?.map((item: any) => {
      return {
        title: item?.title,
        menuLinks: item?.menuLinksCollection?.items?.map((link: any) => {
          const processedUrl = processLinkUrl(link)
          return {
            text: link?.text || link?.url?.text,
            url: processedUrl,
          }
        })
      }
    })
  }

  if ((Object.values(formattedFooterData).filter(item => item != undefined))?.length === 0) {
    // dont return this component if none of the formatted data is there
    return null;
  }
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="t2-footer">
        <SectorFooter
          {...formattedFooterData}
        />
      </div>
    </Suspense>
  );
}
